import type { DialogProps } from '@mui/material/Dialog';

// ----------------------------------------------------------------------

/**
 * Gör en MUI-dialogs Paper till ett riktigt <form>, så att `SkickaFormulärGenväg`
 * (Cmd+Enter) hittar det och kan skicka dialogen.
 *
 * Paper — inte ett inlaggt <form> runt innehållet — eftersom Dialog.Paper är
 * flex-container åt DialogContent; ett extra element däremellan bryter
 * rullningen i långa dialoger.
 *
 * MUI:s Button har `type="button"` som standard, så dialogen får inget
 * submit-anrop av att någon trycker Enter i ett vanligt fält. Vill man ha det
 * också sätter man `type="submit"` på primärknappen.
 *
 * @param vidSkicka  Anropas när formuläret skickas — samma funktion som primärknappens onClick.
 * @param paperProps Eventuella övriga Paper-props (t.ex. `sx`).
 */
export function formulärDialogProps(
  vidSkicka: () => void,
  paperProps?: Record<string, unknown>
): DialogProps['slotProps'] {
  return {
    paper: {
      ...paperProps,
      component: 'form',
      noValidate: true,
      onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        vidSkicka();
      },
    },
  } as unknown as DialogProps['slotProps'];
}
